import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMobile } from '../hooks/useMobile';

const PRIMARY_ITEMS = [
  { path: '/', label: 'Dashboard', icon: 'M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z' },
  { path: '/campaigns', label: 'Campaigns', icon: 'M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z' },
  { path: '/create-campaign', label: 'Create Campaign', icon: 'M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z' },
  { path: '/network', label: 'Network', icon: 'M12 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z' }
];

export const Sidebar = () => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const isMobile = useMobile();

  const isActive = (path) => location.pathname === path;

  return (
    <aside className={`sidebar-shell ${isMobile ? 'sidebar-shell--fixed-mobile' : ''}`}>
      <div className="sidebar-inner">
        <Link to="/" className="sidebar-logo" aria-label="SBWOM home">
          <div className="sidebar-logo__circle">
            <img
              src="/logo.png"
              alt=""
              className="sidebar-logo__image"
            />
          </div>
        </Link>

        <nav className="sidebar-nav" aria-label="Primary">
          <div className="sidebar-nav__stack">
            {PRIMARY_ITEMS.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-nav__item ${isActive(item.path) ? 'sidebar-nav__item--active' : ''}`}
                title={item.label}
              >
                <svg viewBox="0 0 20 20" fill="currentColor" className="sidebar-nav__icon">
                  <path fillRule="evenodd" d={item.icon} clipRule="evenodd" />
                </svg>
                <span className="sidebar-nav__tooltip">{item.label}</span>
              </Link>
            ))}
          </div>

          <div className="sidebar-nav__stack sidebar-nav__stack--footer">
            {currentUser ? (
              <Link
                to="/profile"
                className={`sidebar-nav__item ${isActive('/profile') ? 'sidebar-nav__item--active' : ''}`}
                title="Profile"
              >
                <svg viewBox="0 0 20 20" fill="currentColor" className="sidebar-nav__icon">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                <span className="sidebar-nav__tooltip">Profile</span>
              </Link>
            ) : (
              <Link
                to="/login"
                className={`sidebar-nav__item ${(isActive('/login') || isActive('/register')) ? 'sidebar-nav__item--active' : ''}`}
                title="Sign In / Sign Up"
              >
                <svg viewBox="0 0 20 20" fill="currentColor" className="sidebar-nav__icon">
                  <path fillRule="evenodd" d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="sidebar-nav__tooltip">Sign In / Sign Up</span>
              </Link>
            )}
          </div>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
